import React, { forwardRef, useContext, useImperativeHandle, useRef } from "react";
import Form from "../../Gateway/form";
import { LnsCadastroRapidoContext } from "../../../../contexts/LnsCadastroRapido";

const Gateways = forwardRef((props, ref) => {
  const formRef = useRef();
  const { setGatewayId, gatewayId } = useContext(LnsCadastroRapidoContext);

  useImperativeHandle(ref, () => ({
    onNext: async () => {
      const result = await formRef.current?.handleQuickRegister();

      if (result?.success && result?.gatewayId) {
        setGatewayId(result.gatewayId);
      }
      return result.success
    }
  }));

  return (
    <div>
      <Form ref={formRef} isQuickRegister gatewayId={gatewayId} />
    </div>
  );
});

export default Gateways;